export const CYCLE_TYPES = [
  { id: 'FBC', label: 'FBC' },
  { id: 'RM', label: 'RM' },
  { id: 'IA', label: 'IA' },
  { id: 'OTHERS', label: 'OTHERS' },
];

export const MAIN_TABS = [
  { id: 'templates', label: 'Template' },
  { id: 'customFields', label: 'Fields' },
];

export const ITEMS_PER_PAGE = 25;

/** Max Excel column width for Task Name in bulk-edit / Task Library export (matches Supernova template). */
export const EXPORT_TASK_NAME_MAX_WIDTH = 45;

export const PAGE_DETAILS = {
  module: 'financialclose',
  page: 'setup-tasklist',
};

export function getTableHeaders(locationHeader = 'Location') {
  return [
    { text: '', value: 'select', visible: true, sortable: false, width: '48px' },
    { text: 'Ref', value: 'ref', visible: true, sortable: true, filterable: true },
    { text: 'Task Name', value: 'description', visible: true, sortable: true, filterable: true },
    { text: 'Task Type', value: 'taskTypeDisplay', visible: true, sortable: true, filterable: true },
    { text: 'Category', value: 'category', visible: true, sortable: true, filterable: true },
    { text: 'Sub-Category', value: 'subcategory', visible: true, sortable: true, filterable: true },
    { text: locationHeader, value: 'locationDisplay', visible: true, sortable: true, filterable: true },
    { text: 'Due Days', value: 'duedays', visible: true, sortable: true, filterable: true },
    { text: 'Created On', value: 'createdOn', visible: true, sortable: true, filterable: true },
    { text: 'Frequency', value: 'frequencyDisplay', visible: true, sortable: true, filterable: true },
    { text: 'Action', value: 'action', visible: true, sortable: false },
  ];
}

/** @deprecated Prefer getTableHeaders(locationHeader) so the label tracks LocationHeader. */
export const TABLE_HEADERS = getTableHeaders();

export const CUSTOM_FIELD_TABLE_HEADERS = [
  { text: 'Field Name', value: 'displayName', visible: true, sortable: true, filterable: true },
  { text: 'Data Type', value: 'dataType', visible: true, sortable: true, filterable: true },
  { text: 'Ingestion Type', value: 'ingestionType', visible: true, sortable: true, filterable: true },
  { text: 'Action', value: 'action', visible: true, sortable: false },
];

export function getSystemCustomFields(locationHeader = 'Location') {
  return [
    { displayName: 'Ref', dataType: 'string', ingestionType: 'System', isSystem: true },
    { displayName: 'Task Name', dataType: 'string', ingestionType: 'System', isSystem: true },
    { displayName: 'Task type', dataType: 'string', ingestionType: 'System', isSystem: true },
    { displayName: locationHeader, dataType: 'string', ingestionType: 'System', isSystem: true },
    { displayName: 'Due Days', dataType: 'number', ingestionType: 'System', isSystem: true },
    { displayName: 'Created on', dataType: 'date', ingestionType: 'System', isSystem: true },
    { displayName: 'Frequency', dataType: 'string', ingestionType: 'System', isSystem: true },
  ];
}

/** @deprecated Prefer getSystemCustomFields(locationHeader). */
export const SYSTEM_CUSTOM_FIELDS = getSystemCustomFields();

export const COLUMN_DATA_TYPES = [
  { name: 'string', displayText: 'String' },
  { name: 'number', displayText: 'Number' },
  { name: 'date', displayText: 'Date' },
];

export const BULK_USER_ACTIONS = [
  { name: 'Add', value: 'associate' },
  { name: 'Remove', value: 'remove' },
  { name: 'Replace', value: 'replace' },
  { name: 'Move', value: 'move' },
];

export const ADD_TEMPLATE_TABS = {
  DETAILS: 'details',
  ACCOUNTS: 'accounts',
  ASSIGNMENT: 'assignment',
};

export const BULK_IMPORT_MODES = {
  IMPORT: 'import',
  BULK_EDIT: 'bulkEdit',
};

/**
 * Scalar template fields copied when merging bulk rows (non-empty value wins).
 */
export const BULK_MERGE_SCALAR_KEYS = [
  'description',
  'category',
  'subcategory',
  'purpose',
  'instruction',
  'priority',
  'task_type',
];

/**
 * Details-step required keys checked before advancing Add Template wizard.
 */
export const TEMPLATE_DETAIL_FORM_KEYS = [
  'description',
  'category',
  'subcategory',
  'duedays',
  'priority',
  'tags',
  'assertion',
  'noofevidence',
];

/** Accounts-step keys checked before advancing past Accounts in AR templates. */
export const TEMPLATE_ACCOUNTS_FORM_KEYS = ['glcode'];

/** data-testid prefix for Add Template fields, used to scroll a server error into view. */
export const TEMPLATE_FIELD_TEST_ID_PREFIX = 'setup-tasklist__template-';

/** scrollIntoView block alignment for a server field error. */
export const TEMPLATE_ERROR_SCROLL_BLOCK = 'center';

/**
 * Instruction tab rows for bulk Task Library Excel templates (matches getbulksubmittemplate).
 */
export function getBulkTaskTemplateInstructions(locationHeader = 'Location') {
  const loc = locationHeader || 'Location';
  return [
    "Don't change the 'TOP SHEET' sheet name",
    "Don't change the column headings and the column order",
    '"Task Name" column is mandatory',
    '"Category" column is mandatory',
    '"Sub Category" column is mandatory',
    `"${loc}" column is mandatory`,
    '"Purpose" & "Instruction" column are not mandatory',
    '"Preparer" column is not mandatory. Multiple preparers separated by commas',
    '"Approver" column is not mandatory. Multiple approvers separated by commas',
    '"Sign-Off Approver" column is optional. Blank cell disables Sign-Off; non-blank comma-separated emails enable Sign-Off',
    'Preparer, Approver, and Sign-Off Approver for a line item cannot be the same',
    'In "Frequency" column multiple values separated by comma',
    '"Due Days" is not mandatory',
    '"Account No" is not mandatory, can have multiple',
    '"Priority" must be one of: High, Medium, Low',
    '"No. of Evidences" is optional. If not entered, it will default to 0. Please enter a value between 0 and 10.',
    '"Evidence Required" is optional. Blank or Yes means evidence is required and No. of Evidences must be between 1 and 10. No allows 0.',
    '"Enforce Threshold" is optional. It is applicable only for Account Reconciliation tasks. If not entered, it defaults to Yes.',
    '"Auto-Approve" is optional. If not entered, it will default to false.',
    `Per-${loc} assignments: repeat the same task on consecutive rows with one ${loc} each and different Preparer/Approver/Sign-Off per row. Multi-${loc} on one row: use comma-separated ${loc} values in a single row with shared Preparer/Approver/Sign-Off.`,
    'For Category and Sub Category, you can select from the dropdown or enter a new value',
    `Multiple ${loc} values with the same preparer/approver: use one row with comma-separated ${loc} values`,
    `Different preparer/approver per ${loc}: repeat the same task fields on consecutive rows (one ${loc} per row). Only adjacent matching rows are merged into one template`,
  ];
}

/** @deprecated Prefer getBulkTaskTemplateInstructions(locationHeader). */
export const BULK_TASK_TEMPLATE_INSTRUCTIONS = getBulkTaskTemplateInstructions();

/**
 * Instruction tab for bulk-edit Excel download (selected tasks export).
 */
export function getBulkEditTaskTemplateInstructions(locationHeader = 'Location') {
  const loc = locationHeader || 'Location';
  return [
    "Don't change the 'TOP SHEET' sheet name",
    "Don't change the column headings and the column order",
    '"Reference" column is mandatory and must not be changed',
    '"Task Name" column is mandatory',
    '"Category" column is mandatory',
    '"Sub Category" column is mandatory',
    `"${loc}" column is mandatory`,
    '"Purpose" & "Instruction" column are not mandatory',
    '"Preparer" column is not mandatory. Multiple preparers separated by commas',
    '"Approver" column is not mandatory. Multiple approvers separated by commas',
    '"Sign-Off Approver" column is optional. Blank cell disables Sign-Off; non-blank comma-separated emails enable Sign-Off',
    'Preparer, Approver, and Sign-Off Approver for a line item cannot be the same',
    'In "Frequency" column multiple values separated by comma',
    'In "Assertions" column multiple values separated by comma',
    '"Due Days" is not mandatory',
    '"Account No" is not mandatory, can have multiple',
    '"Priority" must be one of: High, Medium, Low',
    '"No. of Evidences" is optional. If not entered, it will default to 0. Please enter a value between 0 and 10.',
    '"Evidence Required" is optional. Blank or Yes means evidence is required and No. of Evidences must be between 1 and 10. No allows 0.',
    '"Enforce Threshold" is optional. It is applicable only for Account Reconciliation tasks. If not entered, it defaults to Yes.',
    '"Auto-Approve" is optional. If not entered, it will default to false.',
    'One row per assignment: consecutive rows with the same Reference are different assignments for the same task',
  ];
}

/** @deprecated Prefer getBulkEditTaskTemplateInstructions(locationHeader). */
export const BULK_EDIT_TASK_TEMPLATE_INSTRUCTIONS = getBulkEditTaskTemplateInstructions();

/**
 * Known row keys that are NOT custom fields when flattening a bulk-import row
 * into `customfields[]` for the API payload.
 */
export const BULK_IMPORT_ROW_SYSTEM_KEYS = [
  'description',
  'category',
  'subcategory',
  'location',
  'locationNames',
  'preparer',
  'approver',
  'sign_off_approver',
  'sign_off_approvers',
  'requires_sign_off',
  'glcode',
  'purpose',
  'instruction',
  'tags',
  'assertions',
  'duedays',
  'priority',
  'no_of_evidence',
  'evidence_required',
  'enforceThreshold',
  'auto_approve',
  'task_type',
  'ref',
  '_id',
  'cycle_type',
  'customfields',
  '_preparerEmails',
  '_approverEmails',
  '_signOffApproverEmails',
  '_errors',
];
